/* Model */
class ProactiveRouteOptConfigModel extends App.Models.BaseModel {
  modelUrl = "ProactiveRouteOptConfig";
}

App.Models.ProactiveRouteOptConfig = ProactiveRouteOptConfigModel;

/* Collection */
class ProactiveRouteOptConfigCollection extends App.Collections.BaseCollection {
  url = "ProactiveRouteOptConfig";
  model = App.Models.ProactiveRouteOptConfig;
}

App.Collections.ProactiveRouteOptConfigs = ProactiveRouteOptConfigCollection;

const CustomFieldConfig = (checkboxId, inputId) => {
  return () => {
    const checkboxElement = document.getElementById(checkboxId);
    const inputElement = document.getElementById(inputId);

    const field = {
      checked: (value) => {
        checkboxElement.checked = value;
        inputElement.disabled = !value;

        if (!value) {
          inputElement.value = "";
        }
      },
      disabled: (value) => {
        inputElement.disabled = value;
        checkboxElement.disabled = value;
      },
      setValue: (value) => {
        const valueIsTruthy = !!value;

        checkboxElement.checked = valueIsTruthy;
        inputElement.disabled = !valueIsTruthy;
        inputElement.value = value || "";

        if (!valueIsTruthy) {
          inputElement.disabled = true;
        }
      },
    };

    const input = {
      disabled: (value) => {
        inputElement.disabled = value;
      },
      setValue: (value) => {
        inputElement.value = value || "";
      },
      getValue: () => inputElement.value,
    };

    const checkbox = {
      checked: (value) => {
        checkboxElement.checked = value;
      },
      disabled: (value) => {
        checkboxElement.disabled = value;
      },
      getChecked: () => checkboxElement.checked,
    };

    return {
      field,
      input,
      checkbox,
    };
  };
};

/* Router */
class ProactiveRouteOptConfigRouter extends App.Routers.BaseRouter {
  SizeLabel = {
    value: "",
    getResourceFromValue: (resourceName) => {
      const sizeResourceMapping = {
        SIZE_1: "pro.size1",
        SIZE_2: "pro.size2",
        SIZE_3: "pro.size3",
      };

      return resourceName
        ? Monet.I18n.getResourcesByKey(sizeResourceMapping[resourceName])
        : resourceName;
    },
    setValue: (v) => {
      this.SizeLabel.value = this.SizeLabel.getResourceFromValue(v);
    },
  };

  minimalSizePriorization = CustomFieldConfig(
    "prioritizeStopWithVolume",
    "minimalSizePriorization"
  );

  equipmentOccupationPercent = CustomFieldConfig(
    "prioritizeEquipmentOccupation",
    "equipmentOccupationPercent"
  );

  constructor() {
    const entityName = "ProactiveRouteOptConfig";
    const model = App.Models.ProactiveRouteOptConfig;
    const collectionClass = App.Collections.ProactiveRouteOptConfigs;

    super(entityName, model, collectionClass);
  }

  getEquipmentOccupationFeatureFlagValue = () => {
    const featureFlag =
      GreenmileReduxStore.getState().configuration.featureStates.get(
        "PRO_EQUIPMENT_OCCUPATION"
      );

    return featureFlag.enabled || false;
  };

  updateLabelMinimalSize = () => {
    const resource = Monet.I18n.getResourcesByKey("pro.minimalSize");
    const isDisabled = !this.minimalSizePriorization().checkbox.getChecked();

    const field = `<input type="number" name="minimalSizePriorization" id="minimalSizePriorization" min=0 ${
      isDisabled && "disabled"
    }>`;

    const sizeLabel =
      this.SizeLabel.value || this.SizeLabel.getResourceFromValue("SIZE_1");

    const label = resource
      .replace("{textfield}", field)
      .replace(
        "{size1}",
        `<span class="sizeBold" id="sizeLabel">${sizeLabel}</span>`
      );

    App.Forms.ProactiveRouteOptConfig.form.fields.prioritizeStopWithVolume.label.innerHTML =
      label;
  };

  updateEquipmentOccupationLabel = () => {
    const resource = Monet.I18n.getResourcesByKey(
      "pro.prioritizeEquipmentOccupation"
    );
    const isDisabled = !this.equipmentOccupationPercent().checkbox.getChecked();

    const field = `<input type="number" name="equipmentOccupationPercent" id="equipmentOccupationPercent" min=0 ${
      isDisabled && "disabled"
    }>`;

    const sizeLabel =
      this.SizeLabel.value || this.SizeLabel.getResourceFromValue("SIZE_1");

    const label = resource
      .replace("{textfield}", field)
      .replace(
        "{size1}",
        `<span class="sizeBold" id="sizeLabel">${sizeLabel}</span>`
      );

    App.Forms.ProactiveRouteOptConfig.form.fields.prioritizeEquipmentOccupation.label.innerHTML =
      label;
  };

  hideLargeDeliveryAndReset = () => {
    const fields = App.Forms.ProactiveRouteOptConfig.form.fields;
    const optionGroup = fields.largeDeliveryPriorizationType.rootEl;
    const minimalSizeWrapper = fields.prioritizeStopWithVolume.rootEl;

    const prioritizeEquipmentOccupation = document.getElementById(
      "ProactiveRouteOptConfig_prioritizeEquipmentOccupation"
    );

    if (prioritizeEquipmentOccupation) {
      prioritizeEquipmentOccupation.style.display = "none";
    }

    optionGroup.style.display = "none";
    minimalSizeWrapper.style.display = "none";

    this.minimalSizePriorization().field.setValue("");
    this.minimalSizePriorization().field.disabled(true);

    this.equipmentOccupationPercent().field.disabled(true);
    this.equipmentOccupationPercent().field.setValue(null);

    App.Forms.ProactiveRouteOptConfig.form.fields.largeDeliveryPriorizationType.clear();
  };

  handleChangeLargeDeliveryPriorization = (event) => {
    if (event.target.checked) {
      this.showLargeDelivery();
    } else {
      this.hideLargeDeliveryAndReset();
    }
  };

  handleChangeSizePriorization = (event) => {
    this.SizeLabel.setValue(event.target.value);
    this.updateEquipmentOccupationLabel();
    this.updateLabelMinimalSize();
  };

  handleChangePrioritizeStopWithVolume = (event) => {
    const { checked } = event.target;

    const prioritizeEquipmentOccupationField =
      App.Forms.ProactiveRouteOptConfig.form.fields
        .prioritizeEquipmentOccupation;

    this.minimalSizePriorization().field.checked(checked);

    if (checked) {
      prioritizeEquipmentOccupationField.enable();
    } else {
      this.equipmentOccupationPercent().field.disabled(true);
      this.equipmentOccupationPercent().field.setValue(null);
    }
  };

  handleChangePrioritizeEquipmentOccupation = (event) => {
    const { checked } = event.target;

    this.equipmentOccupationPercent().field.checked(checked);

    if (!checked) {
      this.equipmentOccupationPercent().field.setValue(null);
    }
  };

  showLargeDelivery = () => {
    const optionGroup = document.querySelector(
      "div.optionGroup[sectionorder='4']"
    );

    const minimalSizeCheckbox = document.getElementById(
      "ProactiveRouteOptConfig_prioritizeStopWithVolume"
    );
    const equipmentOccupationCheckbox = document.getElementById(
      "ProactiveRouteOptConfig_prioritizeEquipmentOccupation"
    );

    const fields = App.Forms.ProactiveRouteOptConfig.form.fields;

    const featureFlagValue = this.getEquipmentOccupationFeatureFlagValue();

    if (optionGroup) {
      optionGroup.style.display = "block";
    }

    if (minimalSizeCheckbox) {
      minimalSizeCheckbox.style.display = "flex";
    }

    if (featureFlagValue && equipmentOccupationCheckbox) {
      equipmentOccupationCheckbox.style.display = "flex";
    }

    if (!fields.largeDeliveryPriorizationType.getValue()) {
      const resourceSize1 = "SIZE_1";
      fields.largeDeliveryPriorizationType.setValue(resourceSize1);
      this.SizeLabel.setValue(resourceSize1);
    }

    this.minimalSizePriorization().field.disabled(false);
  };

  enableLargeDelivery = () => {
    this.showLargeDelivery();
    const fields = App.Forms.ProactiveRouteOptConfig.form.fields;

    fields.largeDeliveryPriorization.setValue(true);
    this.SizeLabel.setValue(fields.largeDeliveryPriorizationType.getValue());
  };

  enableEquipmentOccupation = () => {
    const fields = App.Forms.ProactiveRouteOptConfig.form.fields;
    fields.prioritizeEquipmentOccupation.setValue(true);
    fields.prioritizeEquipmentOccupation.enable();
  };

  beforePopulateLocalCollection = () => {
    let projection = JSON.parse(this.projection);

    projection.filters.splice(
      projection.filters.indexOf("prioritizeStopWithVolume"),
      1
    );

    projection.filters.splice(
      projection.filters.indexOf("largeDeliveryPriorization"),
      1
    );

    projection.filters.push("minimalSizePriorization");
    projection.filters.push("equipmentOccupationPercent");
    this.projection = JSON.stringify(projection);
  };

  beforeValidate = () => {
    let fields = App.Forms[this.entityName].form.fields;
    fields.minimalSizePriorization = new Monet.UI.Fields.Number();
    fields.equipmentOccupationPercent = new Monet.UI.Fields.Number();

    fields.minimalSizePriorization.render();
    fields.equipmentOccupationPercent.render();

    fields.minimalSizePriorization.setValue(
      this.minimalSizePriorization().input.getValue()
    );
    fields.minimalSizePriorization.name = "minimalSizePriorization";

    fields.equipmentOccupationPercent.setValue(
      this.equipmentOccupationPercent().input.getValue()
    );
    fields.equipmentOccupationPercent.name = "equipmentOccupationField";
  };

  afterPopulateForm = (model) => {
    if (model && model.attributes) {
      const {
        minimalSizePriorization,
        equipmentOccupationPercent,
        largeDeliveryPriorizationType,
      } = model.attributes;

      if (largeDeliveryPriorizationType) {
        this.enableLargeDelivery();
      }

      if (minimalSizePriorization) {
        this.minimalSizePriorization().field.setValue(minimalSizePriorization);

        if (!equipmentOccupationPercent) {
          this.equipmentOccupationPercent().checkbox.disabled(false);
        }
      }

      if (equipmentOccupationPercent) {
        this.equipmentOccupationPercent().field.setValue(
          equipmentOccupationPercent
        );
        this.equipmentOccupationPercent().checkbox.disabled(false);
      }
    }
  };

  afterCreateForm = () => {
    const reoganizeRadioInputs = function () {
      const optmizationObjectivesContainer = document.querySelector(
        "#ProactiveRouteOptConfig .lookupFieldContainer + .optionGroup"
      );

      const largeDeliveryOptionsContainer = document.querySelector(
        "div.optionGroup[sectionorder='4']"
      );

      if (optmizationObjectivesContainer) {
        const wrapper = document.createElement("div");
        wrapper.classList.add("optionsWrapper");
        optmizationObjectivesContainer.appendChild(wrapper);

        const options = document.querySelectorAll(
          "#ProactiveRouteOptConfig .lookupFieldContainer + .optionGroup > .radio_group_item"
        );

        if (options && options.length) {
          options.forEach((opt) => wrapper.appendChild(opt));
        }
      }

      if (largeDeliveryOptionsContainer) {
        const wrapper = document.createElement("div");
        wrapper.classList.add("optionsWrapper");
        largeDeliveryOptionsContainer.appendChild(wrapper);

        const options = document.querySelectorAll(
          "div.optionGroup[sectionorder='4'] > .radio_group_item"
        );

        if (options && options.length) {
          options.forEach((opt) => wrapper.appendChild(opt));
        }
      }
    };

    const addEventListeners = () => {
      const largeDeliveryPriorization = document.getElementById(
        "largeDeliveryPriorization"
      );

      const prioritizeStopWithVolume = document.getElementById(
        "prioritizeStopWithVolume"
      );

      const prioritizeEquipmentOccupation = document.getElementById(
        "prioritizeEquipmentOccupation"
      );

      const sizePriorizationOptions = document.querySelectorAll(
        "div.optionGroup[sectionorder='4'] > .optionsWrapper > .radio_group_item > input[type='radio']"
      );

      largeDeliveryPriorization.addEventListener(
        "change",
        this.handleChangeLargeDeliveryPriorization
      );

      prioritizeStopWithVolume.addEventListener(
        "change",
        this.handleChangePrioritizeStopWithVolume
      );

      if (prioritizeEquipmentOccupation) {
        prioritizeEquipmentOccupation.addEventListener(
          "change",
          this.handleChangePrioritizeEquipmentOccupation
        );
      }

      if (sizePriorizationOptions) {
        sizePriorizationOptions.forEach((input) => {
          input.addEventListener("change", this.handleChangeSizePriorization);
        });
      }
    };

    reoganizeRadioInputs();
    this.updateLabelMinimalSize();
    this.updateEquipmentOccupationLabel();
    addEventListeners();

    //set default value for large delivery priorization field
    const fields = App.Forms.ProactiveRouteOptConfig.form.fields;

    fields.largeDeliveryPriorization.setValue(false);
    if (fields.prioritizeEquipmentOccupation) {
      fields.prioritizeEquipmentOccupation.setValue(false);
      fields.prioritizeEquipmentOccupation.disable();
    }

    const featureFlagValue = this.getEquipmentOccupationFeatureFlagValue();

    if (!featureFlagValue) {
      fields.prioritizeEquipmentOccupation.hide();
    }
  };
}

App.Routers.ProactiveRouteOptConfig = ProactiveRouteOptConfigRouter;
